import { accountService } from '@libs/data-access/queries'

export const useGetAccountFlipperFeatureFlags = () => {
  return accountService.featureFlags.useFetchAllForAccount()
}
